import React from 'react';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import KanbanColumn from './KanbanColumn';

const KanbanBoard = ({ lanes, onCardMove, onLaneReorder, updateTicket, isAdmin, busy }) => (
  <DragDropContext onDragEnd={({ source, destination, draggableId, type }) => {
    if (!destination || busy) return;
    if (type === 'LANE') {
      if (source.index !== destination.index) onLaneReorder(source.index, destination.index);
    } else if (source.droppableId !== destination.droppableId) {
      onCardMove(Number(draggableId.split(':').pop()), destination.droppableId);
    }
  }}>
    <Droppable droppableId="lanes" direction="horizontal" type="LANE">
      {provided => <div className="zk-board" ref={provided.innerRef} {...provided.droppableProps}>
        {lanes.map((lane, index) => <KanbanColumn key={lane.id} {...lane} index={index} updateTicket={updateTicket} isAdmin={isAdmin} busy={busy} />)}
        {provided.placeholder}
      </div>}
    </Droppable>
  </DragDropContext>
);

export default KanbanBoard;
